import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useTeamComposition } from "../../Hooks/Features/ProjectGlance/useTeamComposition"
import TeamDetailsPopup from "./TeamDetailsPopup"
import { SkeletonContainer } from "../Loader/Loader"

const TeamComposition = ({ projectId, projectName }) => {

    const card = "team_composition";
    const { teamSummary, getIcon, details, setDetails, loader } = useTeamComposition({ projectId, card });

    return (
        <div className='h-100'>
            <div className="fs-6 fw-semibold d-flex gap-2 align-items-center p-1 pb-2">
                <div className='srkay-users-group fw-semibold' />Team Composition
            </div>
            <div className="d-flex flex-wrap gap-2">
                {loader?.team_comp ? <div className="w100" style={{ height: "100px" }}><SkeletonContainer /></div> : teamSummary?.map(item => {
                    const iconInfo = getIcon(item?.category_key);
                    if (item?.category_wise_counts <= 0) return
                    return (
                        <div key={item?.category_id} className={`project-glance-card-section c-pointer d-flex align-items-center gap-2 rounded p-2`} style={{ backgroundColor: "var(--bg-light)", width: "19%" }} onClick={() => { setDetails((prev) => ({ ...prev, visible: true, data: item })) }}>
                            <FontAwesomeIcon icon={iconInfo?.icon} style={{ color: iconInfo?.color || "var(--text-color)" }} />
                            <div className="w90">
                                <div className="fw-bold fs-5">{item?.category_wise_counts}</div>
                                <div className="text-truncate w100" style={{ color: "var(--text-color)", opacity: 0.7, fontSize: "0.75rem" }}>{item?.category_name}</div>
                            </div>
                        </div>
                    )
                })}
            </div>
            {details?.visible && <TeamDetailsPopup projectId={projectId} projectName={projectName} details={details} onClose={() => setDetails((prev) => ({ ...prev, visible: false, data: {} }))} />}
        </div>
    )
}

export default TeamComposition